/* eslint-disable camelcase */
import trans from '@/utils/translation';
import { createI18n } from 'vue-i18n';
import en_general from './lang/en/general.json';
import es_general from './lang/es/general.json';
import en_home from './lang/en/home.json';
import es_home from './lang/es/home.json';
import en_not_found from './lang/en/not-found.json';
import es_not_found from './lang/es/not-found.json';
import en_maintenance from './lang/en/maintenance.json';
import es_maintenance from './lang/es/maintenance.json';
import en_auth from './lang/en/auth.json';
import es_auth from './lang/es/auth.json';
import en_donor from './lang/en/donor.json';
import es_donor from './lang/es/donor.json';

const messages = {
    en: {
        ...en_general,
        ...en_home,
        ...en_not_found,
        ...en_maintenance,
        ...en_auth,
        ...en_donor
    },
    es: {
        ...es_general,
        ...es_home,
        ...es_not_found,
        ...es_maintenance,
        ...es_auth,
        ...es_donor
    }
};

const i18n = createI18n({
    locale: trans.guessDefaultLocale(),
    fallbackLocale: 'en',
    messages,
    legacy: false,
    globalInjection: true
});

export default i18n;
